export {default as BoxTemplate1} from './box'